// 🔐 Register / Welcome
// Goal: fast, frictionless entry.
// Use Clerk components (SignUp).
// Minimal layout: centered card on neutral background.
// Branding: small logo.
// CTA → "Sign up with Google" as primary button.
// 👉 Best practice: no extra fields — auth first, profile later.

import { createFileRoute } from '@tanstack/react-router';
import { SignUp } from '@clerk/clerk-react';

export const Route = createFileRoute('/signup')({
  component: SignUpPage,
});

function SignUpPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/50">
      <div className="w-full max-w-md space-y-8 p-8">
        {/* Clerk Sign Up */}
        <div className="flex justify-center">
          <SignUp
            appearance={{
              elements: {
                formButtonPrimary: 'bg-primary hover:bg-primary/90',
                card: 'shadow-sm',
              },
            }}
            redirectUrl="/"
          />
        </div>
      </div>
    </div>
  );
}
